export default {
    "title": "Panel de Administración Extranet / Documentación",
    "nameCollection": "Documentos",
    "description": "Listado de documentos",
    "name": "Nombre documento ",
    "totalDocumentation": "Documentos totales: <0>{{count}}</0>",
    "clientName": "Nombre cliente",
    "download": "Descargar",
    "client": "Cliente",
    "startDate": "Fecha de inicio ",
    "endDate": "Fecha de caducidad ",
    "fromStartDate": "Fecha de inicio desde ",
    "toStartDate": "Fecha de inicio hasta ",
    "fromEndDate": "Fecha de caducidad desde ",
    "toEndDate": "Fecha de caducidad hasta ",
    "type": "Tipo",
    "size": "Tamaño"
}